export async function loadSprites() {
    try {
        const response = await fetch("/wp-content/themes/smartpos/_sprites.php");
        const html = await response.text();

        document.body.insertAdjacentHTML("afterbegin", html);
    } catch (e) {
        console.log("Не удалось загрузить спрайты: ", e.message);
    }
}